import { SidePanelLayerType } from "@nova/constants"
import { PluginRegistry } from "plugins/plugin-registry"
import * as Icons from "@nova/component-icons"
import { deletePDFJob, updatePDFJob } from "features/pubsub/entityActions/jobs/pdf"
import { PDFJob } from "@nova/protobuf"
import { selectPDFById, selectPDFJobs } from "./PDFSlice"
import { usePDFStatusAndProgress } from "panels/content/side-panel/progress/PDF"

export function registerPdfPlugin(registry: PluginRegistry) {
    registry
        .register<PDFJob>({
            name: "pdfs",
            displayName: "PDF",
            sidePanelLayerType: SidePanelLayerType.PDF,
            PrimaryIcon: Icons.PDFIcon,
            updateAction: updatePDFJob,
            deleteAction: deletePDFJob,
            confirmDelete: () => false,
            protobufMessage: PDFJob,
            selectAllEntities: selectPDFJobs,
            selectSingleEntity: selectPDFById,
            useUploadStatusAndProgress: usePDFStatusAndProgress,
            zoomTo: () => undefined,
            duplicate: () => undefined,
        })
        .implement("side-panel-pdf-plugin")
}
